import DropdownItem from './dropdown_item';
import DropdownCharts from '../dropdown_charts';
export default class Chart extends DropdownItem {
  constructor() {
    super('chart');
  }
  dropdown() {
    return new DropdownCharts();
  }
}